import React, { useEffect, useState, useRef } from "react";
import { Formik } from "formik";
import { Toast, ToastContainer } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import Select from "react-select";
import { baseURL } from "../../config";

function AssignActionForm() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const [selectedPlanType, setSelectedPlanType] = useState();
  const [posts, setPosts] = useState({ trainings: [] });
  const [showToast, setShowToast] = useState(false);
  const navigate = useNavigate();
  const usernameRef = useRef(null);
  const [teamMembers, setTeamMembers] = useState([]);
  const id = localStorage.getItem("employeeid");

  const handleCloseModal = () => {
    setShowModal(false);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getteamlist?id=` + id
        );
        const data = response.data;
        let arrTeamdata = data.team;
        setTeamMembers(arrTeamdata);

        // console.log(data);
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchData();
  }, []);

  const handleSubmit = async (values, { setSubmitting }) => {
    setFormData(values); // Store form data before displaying the modal
    setShowModal(true); // Show the confirmation modal
  };

  const handleConfirmSubmit = async () => {
    try {
      const response = await fetch(
        `${baseURL}/addassignstaffaction`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        setFormData(null);
        setShowModal(false);
        setShowToast(true);
        setTimeout(() => {
          setShowToast(false);
          navigate("/myteamplanidp");
        }, 3000);
        // window.location.href = "/myteamplanidp";
      } else {
        console.error("Form submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          plantypeaction: "Action",
          planneddateaction: "",
          targetgroup: [],
          justificationaction: "",
        }}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <div className="container">
            <h4 className="text-start pb-2">ASSIGN TO STAFF</h4>
            <div className="col-lg-12 mt-1 m-5">
              <form noValidate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-5 ">
                    <label>Plan Type</label>
                    <select
                      className="form-select form-control"
                      name="plantypeaction"
                      value={values.plantypeaction}
                      onChange={(e) => {
                        setSelectedPlanType(e.target.value);
                        handleChange(e);
                        if (e.target.value === "Training") {
                          window.location.href = "/assigntostaff"; // Navigate to "/assigntostaff" if "Training" is selected
                        }
                      }}
                    >
                      <option value="">Select Plan Type</option>
                      <option value="Training">Training</option>
                      <option value="Action">Action</option>
                    </select>
                  </div>
                  <hr className="hr mt-5 w-75" />

                  <div className="col-lg-12 mt-3">
                    <div className="row">
                      <div className="col-lg-5">
                        <label>Due Date</label>
                        <br />
                        <input
                          type="date"
                          className="form-control"
                          name="planneddateaction"
                          value={values.planneddateaction}
                          onChange={handleChange}
                        ></input>
                      </div>
                      <div className="col-lg-5 ml-5">
                        <label>Target Group</label>
                        <br />
                        <Select
                          className=""
                          name="targetgroup"
                          value={values.targetgroup.map((value) => ({
                            value,
                            label: value,
                          }))}
                          onChange={(selectedOptions) => {
                            const selectedValues = selectedOptions.map(
                              (option) => option.value
                            );
                            setFieldValue("targetgroup", selectedValues);
                          }}
                          options={teamMembers.map((member, index) => ({
                            value: member.employeeid,
                            label: member.FirstName,
                          }))}
                          getOptionLabel={(option) =>
                            `${option.label} - ${option.value}`
                          }
                          isMulti
                        />
                      </div>
                      <div className="col-lg-5 mt-5">
                        <label>Justification</label>
                        <textarea
                          className="form-control h-100"
                          placeholder="Provide justification"
                          name="justificationaction"
                          value={values.justificationaction}
                          onChange={handleChange}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-11 text-end mt-5 pb-3">
                  <button
                    type="submit"
                    className="border-0 mt-3 p-1 savebtn fst-normal"
                  >
                    Save
                  </button>
                  <a href="/listelement" className="text-decoration-none ">
                    <Button
                      type="button"
                      className="btn cancelbtn ml-2"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </Button>
                  </a>
                </div>
              </form>
            </div>
          </div>
        )}
      </Formik>

      {/* Confirmation Modal */}
      <div className="col-lg-12">
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>Do You Want to Confirm the changes?</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleConfirmSubmit}>
              Yes
            </Button>
            <Button variant="secondary" onClick={handleCloseModal}>
              No
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <div>
        <ToastContainer position="bottom-end" className="p-3">
          <Toast
            onClose={() => setShowToast(false)}
            show={showToast}
            delay={3000}
            autohide
            className="bg-success text-white"
          >
            <Toast.Header>
              <span className="me-2">✔️</span> {/* Unicode tick mark */}
              <strong className="me-auto">Notification</strong>
            </Toast.Header>
            <Toast.Body>Success!, data updated successfully!</Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
    </>
  );
}

export default AssignActionForm;
